import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Sliders, Save, AlertTriangle } from 'lucide-react';

const AdvancedSettings = () => {
  const { api } = useAuth();
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [form, setForm] = useState({
    maintenance_mode: false, maintenance_message: 'Site under maintenance',
    allow_comments: true, require_comment_approval: false,
    max_video_size_mb: 500, allowed_video_formats: ['mp4', 'webm', 'avi', 'mov'],
    enable_analytics: true
  });

  useEffect(() => {
    api.get('/admin/system').then(r => setForm(r.data)).catch(console.error);
  }, []);

  const handleSave = async () => {
    setSaving(true); setMsg('');
    try {
      const { _id, ...data } = form;
      await api.put('/admin/system', data);
      setMsg('System settings saved!');
    } catch (err) { setMsg('Error saving'); }
    setSaving(false);
  };

  return (
    <div className="admin-section">
      <div className="section-header">
        <h2 className="section-title"><Sliders size={20} /> Advanced Settings</h2>
        <button className="btn-primary" onClick={handleSave} disabled={saving}>
          <Save size={16} /> {saving ? 'Saving...' : 'Save Settings'}
        </button>
      </div>
      {msg && <div className="form-msg" style={{ marginBottom: 16 }}>{msg}</div>}

      <div className="two-col">
        <div className="admin-card">
          <h3 className="card-subtitle">Maintenance</h3>
          {form.maintenance_mode && (
            <div style={{ padding: 10, background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 8, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
              <AlertTriangle size={16} style={{ color: '#ef4444' }} />
              <span style={{ fontSize: 12, color: '#ef4444', fontWeight: 700 }}>Website is in maintenance mode!</span>
            </div>
          )}
          <div className="toggle-wrap">
            <button type="button" className={`toggle-switch ${form.maintenance_mode ? 'active' : ''}`}
              onClick={() => setForm({...form, maintenance_mode: !form.maintenance_mode})} />
            <span className="toggle-label">Maintenance Mode</span>
          </div>
          <label className="form-label" style={{ marginTop: 12 }}>Maintenance Message</label>
          <input className="form-input" value={form.maintenance_message || ''} onChange={e => setForm({...form, maintenance_message: e.target.value})} />
        </div>

        <div className="admin-card">
          <h3 className="card-subtitle">Comments</h3>
          <div className="toggle-wrap">
            <button type="button" className={`toggle-switch ${form.allow_comments ? 'active' : ''}`}
              onClick={() => setForm({...form, allow_comments: !form.allow_comments})} />
            <span className="toggle-label">Allow Comments</span>
          </div>
          <div className="toggle-wrap">
            <button type="button" className={`toggle-switch ${form.require_comment_approval ? 'active' : ''}`}
              onClick={() => setForm({...form, require_comment_approval: !form.require_comment_approval})} />
            <span className="toggle-label">Require Comment Approval</span>
          </div>
        </div>
      </div>

      <div className="two-col" style={{ marginTop: 16 }}>
        <div className="admin-card">
          <h3 className="card-subtitle">Video Upload</h3>
          <label className="form-label">Max Video Size (MB)</label>
          <input className="form-input" type="number" value={form.max_video_size_mb || 500}
            onChange={e => setForm({...form, max_video_size_mb: parseInt(e.target.value) || 500})} />
          <label className="form-label">Allowed Formats</label>
          <input className="form-input" value={(form.allowed_video_formats || []).join(', ')}
            onChange={e => setForm({...form, allowed_video_formats: e.target.value.split(',').map(f => f.trim()).filter(Boolean)})} />
        </div>

        <div className="admin-card">
          <h3 className="card-subtitle">Analytics</h3>
          <div className="toggle-wrap">
            <button type="button" className={`toggle-switch ${form.enable_analytics ? 'active' : ''}`}
              onClick={() => setForm({...form, enable_analytics: !form.enable_analytics})} />
            <span className="toggle-label">Enable Analytics Tracking</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedSettings;
